import Menu from '../../../components/Peyks/Menu'
import { MapContainer, TileLayer, FeatureGroup } from 'react-leaflet'

export default function index() {
  // eslint-disable-next-line no-unused-vars
  document.title = 'مانیتورینگ'

  return (
    <main id='dashboard'>
      <Menu page={'monitoring'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='dashboardBody'>
        <section className='dashboardContent'>
          <form action="" className='form'>
            <div className='map'>
              <MapContainer center={[37.27579, 49.937]} zoom={13} scrollWheelZoom={false} style={{ height: '600px' }}>
                <FeatureGroup>
                </FeatureGroup>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </MapContainer>
            </div>
          </form>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
